<template>
  <ReviewAndSubmitComponent :updateKey="false">
    <div class="review-and-submit-section">
      <h3 class="review-subheading">My excess</h3>
      <table class="review-and-submit-table">
        <tbody>
          <tr>
            <th>Current excess</th>
            <td>{{ formatAsCurrency(currentExcess) }}</td>
          </tr>
          <tr class="info">
            <th>New excess</th>
            <td>{{ formatAsCurrency(newExcess) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="review-and-submit-section">
      <h3 class="review-subheading">My premium</h3>
      <table class="review-and-submit-table">
        <tbody>
          <tr>
            <th>Current premium</th>
            <td>{{ formatToDisplayCurrencyPeriod(currentPremiumAndFrequency.premium, currentPremiumAndFrequency.frequency) }}</td>
          </tr>
          <tr class="info">
            <th>New premium</th>
            <td>{{ formatToDisplayCurrencyPeriod(newPremiumAndFrequency.premium, newPremiumAndFrequency.frequency) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ReviewAndSubmitComponent>
</template>

<script>
import { ReviewAndSubmitComponent } from '@/components';
import ChangeExcessMixins from '../ChangeExcessMixins';

export default {
  name: 'ReviewAndSubmit',

  mixins: [ChangeExcessMixins],

  components: {
    ReviewAndSubmitComponent,
  },
};
</script>

<style lang="scss" scoped>

</style>